<div class="corner-ribbon top-left sticky {{environmentRibbonBackground}}" *ngIf="environmentRibbonText && environmentRibbonBackground">{{environmentRibbonText}}</div>
